import { render, staticRenderFns } from "./kr-boxplot-chart.vue?vue&type=template&id=a7046866&scoped=true&"
import script from "./kr-boxplot-chart.vue?vue&type=script&lang=js&"
export * from "./kr-boxplot-chart.vue?vue&type=script&lang=js&"
import style0 from "./kr-boxplot-chart.vue?vue&type=style&index=0&id=a7046866&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7046866",
  null
  
)

export default component.exports